<template>
  <a-row
    type="flex"
    justify="space-between"
    class="pointer"
    :style="customizedStyle"
    align="middle">
    <a-col>
      <div class="title">
        <a-row type="flex" align="middle">
          <a-col>
            <div class="line"></div>
          </a-col>
          <a-col>
            <span class="name">{{ textName }}</span>
          </a-col>
          <a-col>
            <slot name="pre_btn"></slot>
          </a-col>
        </a-row>
      </div>
    </a-col>
    <a-col>
      <slot name="btn"></slot>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    textName: {
      type: String,
      default: '控制台'
    },
    customizedStyle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.pointer {
  padding: 15px 0;
  box-shadow: 0px 1px 0px 0px rgba(238,238,238,1);
  margin-bottom: 10px;
}
.title {
  // border-left: 2px solid #4977FC;
  // padding-left: 10px;
  color: #303030;
  font-weight:bold;
  .line {
    width: 4px;
    height: 16px;
    background: #4977FC;
  }
  .name {
    padding: 0 10px;
  }
}
</style>
